class DnDRotate {
    constructor() {
        this.temp = -1;
        this.angleObj = { angle: 0 };
    }

    loop() {
        this.drawRotated(this.angleObj.angle);
        if (this.angleObj.angle === this.temp) {
            TweenLite.ticker.removeEventListener("tick", this.loop.bind(this));
        }
        this.temp = this.angleObj.angle;
    }

    drawRotated(degrees) {
        $("#animation_vongquay").css("transform", `rotate(${degrees}deg)`);
    }

    animateRotate(targetAngle) {
        TweenMax.to(this.angleObj, 5, {
            angle: targetAngle,
            delay: 0,
            repeat: 0
        });

        setTimeout(() => {
            TweenLite.ticker.addEventListener("tick", this.loop.bind(this));
        }, 0);
    }
}

const AnimationLucky = (indexImg, countItems) => {
    const rotateModule = new DnDRotate();
    const ketQua = Math.floor(indexImg * (360 / countItems)) + 360 * 3;
    rotateModule.animateRotate(ketQua);
};

import { random } from 'lodash';
import './tweenmax.js';
window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;
    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 5000,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            if (prizeIndex >= 13) {
                $("#popup_reward .content .text p").hide();
            }
            
            var indexCircle = Math.floor(Math.random() * 8) + 1;
            //console.log("item__" + indexCircle);
            AnimationLucky(Number(indexCircle),8);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
   
        },
    })

});
